import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './Credit.css'
import { Locale } from '../../components/Locale'
import LanguageOption from '../../components/LanguageOption'
import { usePageLayout } from '../../hooks/usePageLayout'
import { getUserCredit, GetUserCreditOutput } from '../../sdk/user'
import { useToken } from '../../hooks/useToken'

let is_ready = true

export default function Credit() {
  const { token, logout } = useToken()

  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: {
        en: 'Credits',
        zh_cn: '点数',
        zh_hk: '點數',
      },
    }),
    [],
  )

  // Credit page should show all navigation elements
  usePageLayout(layoutOptions)

  const [profile, setProfile] = useState<GetUserCreditOutput | null>(null)
  useEffect(() => {
    if (token) {
      getUserCredit({}).then(setProfile)
    }
  }, [token])

  return (
    <div className="Credit">
      {profile && (
        <div className="section card profile-credit">
          <div className="section-title">
            <Locale en="Credits" zh_cn="点数" zh_hk="點數" />
          </div>
          <div className="section-content credit">
            <div className="">
              <div className="credit-usable">
                <Locale
                  en="Remain Credit"
                  zh_cn="可使用点数"
                  zh_hk="可使用點數"
                />
                : {profile.credit + profile.subscription_credit}{' '}
                <Locale en="points" zh_cn="点" zh_hk="點" />
              </div>
              <div className="credit-info">
                <Locale en="from top-up" zh_cn="来自充值" zh_hk="來自儲值" />:{' '}
                {profile.credit} <Locale en="points" zh_cn="点" zh_hk="點" />
              </div>
              <div className="credit-info">
                <Locale
                  en="from monthly subscription"
                  zh_cn="来自每月订阅"
                  zh_hk="來自每月訂閱"
                />
                :{' '}
                {profile.subscription_plan_credit > 0 && (
                  <>
                    {profile.subscription_credit} /{' '}
                    {profile.subscription_plan_credit}{' '}
                    <Locale en="points" zh_cn="点" zh_hk="點" />
                  </>
                )}
                {profile.subscription_plan_credit == 0 && (
                  <>
                    <Link to="/subscription">
                      <span className="link">
                        <Locale
                          en="No Subscription"
                          zh_cn="未订阅"
                          zh_hk="未訂閱"
                        />
                      </span>
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <h2>
        <Locale
          en="Choose Your Option"
          zh_cn="选择您的选项"
          zh_hk="選擇您的選項"
        />
      </h2>

      {!is_ready && (
        <p className="coming-soon-message">
          <Locale en="Coming soon!" zh_cn="即将推出！" zh_hk="即將推出！" />
        </p>
      )}

      <Link
        to="/top-up"
        className={`option ${is_ready ? '' : 'coming-soon-feature'}`}
      >
        <h3 className="option-title">
          <Locale en="Top-Up Credit" zh_cn="充值点数" zh_hk="充值點數" />
        </h3>
        <p className="option-description">
          <Locale
            en="Best value for experiment and exploration!"
            zh_cn="适合实验和探索！"
            zh_hk="適合實驗和探索！"
          />
        </p>
      </Link>
      <Link
        to="/subscription"
        className={`option ${is_ready ? '' : 'coming-soon-feature'}`}
      >
        <h3 className="option-title">
          <Locale en="Subscription Plan" zh_cn="包月计划" zh_hk="月費計劃" />
        </h3>
        <p className="option-description">
          <Locale
            en="Perfect for frequent creators!"
            zh_cn="适合经常使用的用户！"
            zh_hk="適合經常使用的用戶！"
          />
        </p>
      </Link>
    </div>
  )
}

/*
Title (English),Title (zh_cn),Title (zh_hk),Description (English),Description (zh_cn),Description (zh_hk)
Add Credits Now,立即添加点数,即時添加點數,Flexible boosts for quick tests and ideas!,灵活补充，用于快速测试和创意！,靈活補充，用於快速測試和創意！
Buy More Credits,购买更多点数,購買更多點數,Ideal for occasional dives into creativity!,适合偶尔深入创意的用户！,適合偶爾深入創意的用戶！
Instant Credit Boost,即时点数提升,即時點數提升,Great for one-off projects and trials!,适合一次性项目和试用！,適合一次性項目和試用！
Recharge Balance,充值余额,充值餘額,Perfect for exploring without commitment!,适合无承诺的探索！,適合無承諾的探索！
*/

/*
Title (English),Title (zh_cn),Title (zh_hk),Description (English),Description (zh_cn),Description (zh_hk)
Monthly Access Plan,月度访问计划,月度存取計劃,Seamless unlimited creation every month!,每月无缝无限创作！,每月無縫無限創作！
Recurring Creator Pass,recurring创作者通行证,定期創作者通行證,Tailored for daily makers and innovators!,专为日常创作者和创新者设计！,專為日常創作者和創新者設計！
Ongoing Subscription,持续订阅,持續訂閱,Best for steady workflow and endless ideas!,适合稳定工作流和无限想法！,適合穩定工作流和無限想法！
Premium Monthly,高级月度,高級月度,Unlock full potential for regular use!,为经常使用解锁全部潜力！,為經常使用解鎖全部潛力！
*/
